module.exports = __webpack_public_path__ + "media/common/img/disabled_eo_inboxes_settings-47f202a7ee04198b55c4bc3ef3943055.png";